import { Component, Input, OnInit } from '@angular/core';
import { TYPE_IROPS } from '@app/enums/irops.enum';

@Component({
    selector: 'flight-status-alert',
    templateUrl: './flight-status-alert.component.html',
    styleUrls: ['./flight-status-alert.component.scss'],
    standalone: false
})
export class FlightStatusAlertComponent implements OnInit {
  typeIrops = TYPE_IROPS;
  @Input() typeAlert: TYPE_IROPS | 'closed' = this.typeIrops.DELAYED
  @Input() typeAlertOn: string = '';
  constructor() { }

  ngOnInit() {
  }

}
